import { render, staticRenderFns } from "./score-distribution-secret-items.vue?vue&type=template&id=ddd8d01a&scoped=true"
import script from "./score-distribution-secret-items.vue?vue&type=script&lang=js"
export * from "./score-distribution-secret-items.vue?vue&type=script&lang=js"
import style0 from "./score-distribution-secret-items.vue?vue&type=style&index=0&id=ddd8d01a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd8d01a",
  null
  
)

export default component.exports